import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators  } from "@angular/forms";
import { FormHelperService } from "../../../services/form-helper.service";
import { ActivatedRoute, Router } from "@angular/router";
import { LogementService } from "../../../services/logement.service";
import { Logement } from "../../../models/logement";
import { Location } from '@angular/common';
import { ToastService } from "../../../services/toast.service";

@Component({
    selector: 'app-owner-add',
    templateUrl: './owner-add.component.html',
    styleUrls: ['./owner-add.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OwnerAddComponent implements OnInit {

  logement: Logement;
  form: UntypedFormGroup;
  owners: any;

  constructor(
    private logementService: LogementService,
    private fb: UntypedFormBuilder,
    private fh: FormHelperService,
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.logementService.findById(id).then(logement => {
        this.logement = logement;
      });
      this.logementService.getOwnersByLogement(id).then(response => {
        this.owners = response
      });
    }

    this.form = this.fb.group({
      civility: ['MONSIEUR'],
      lastname: [''],
      firstname: [''],
      email: ['']
    });
  }

  backClicked() {
    this._location.back();
  }

  save() {
    const owner = this.form.getRawValue();
    this.logementService.addOwner(this.logement, owner).then(response => {
      this.toastService.show(response.message, {classname: 'toast-' + response.status});
      if (response.status == 'error') {
        this.fh.setSymfonyFormErrors(this.form, response.errors, true);
        return;
      }
      this.router.navigate(['/mes-logements']);
    });
  }
}
